<div class="grouper-container">
    <div class="header">
        <span
            class="circle-outline"
            [class.selected]="isSelected && !readonly && !isMandatory"
            [class.mandatory]="isMandatory"
            (click)="toggleSelected($event)"
            *ngIf="isSelectable && !readonly"></span>

        <i class="{{ baseData.icon }}"
           [class.clickable]="baseData.tooltipDescription"
           (click)="toggleDescription()"></i>

        <div class="details"
            (click)="toggleDropdown()">
            <strong> {{ baseData.title }} </strong>
            <p>{{ baseData.subtitle }}</p>
        </div>

        <div class="link"
             *ngIf="linkData?.link"
             (click)="onLinkClicked()">
            <i class="{{ linkData?.icon }}"></i>
            <div class="link-label">
                {{ linkData?.label }}
            </div>
        </div>

        <div class="delete"
             *ngIf="!readonly && !grouperOnly"
             [class.ml-auto]="!linkData?.link"
             (click)="onDeleteRecurrence($event)">
             <i class="fa fa-trash"></i>
        </div>
    </div>

    <div class="content"
         *ngIf="isContentVisible && !grouperOnly">

        <div class="list-item"
             *ngFor="let item of items">
             <!-- TODO: make the info displayed to be correct -->
            <app-task [task]="item"
                      [canDelete]="!readonly"
                      [canHighlight]="false"
                      (delete)="onDeleteTask($event)"
                      (click)="onItemClicked($event)"
            ></app-task>
            <br>
        </div>

        <div class="empty-content"
             *ngIf="items?.length == 0">
            <i class="fa fa-frown-o"></i>
            <div class="nothing-message">
                {{
                    "admin.toolMaintenancePlans.logicalGrouper.nothing"
                        | translate
                }}
            </div>
            <div class="yet-message">
                {{
                    "admin.toolMaintenancePlans.logicalGrouper.yet"
                        | translate
                }}
            </div>
        </div>
        <div
            class="add-button"
            (click)="openSelectionModal()"
            *ngIf="dropdownItems.length > 0 && !readonly">
            {{
                "admin.toolMaintenancePlans.logicalGrouper.add"
                    | translate
            }}
        </div>
    </div>

    <div class="arrow-container"
         *ngIf="!grouperOnly"
         [class.open]="isContentVisible"
         (click)="toggleDropdown()">

        <i class="fa fa-chevron-up"
           *ngIf="isContentVisible"></i>
        <i class="fa fa-chevron-down"
           *ngIf="!isContentVisible"></i>

    </div>

    <div class="description-wrapper"
         *ngIf="isDescriptionVisible && baseData.tooltipDescription">
        <app-textarea [formControl]="descriptionForm">
        </app-textarea>
    </div>
</div>

<app-task-selection-modal [title]="'admin.toolMaintenancePlans.taskSelectionModal.title' | translate"
                          [tasks]="dropdownItems"
                          [hasOverlay]="false"
                          (select)="handleSelectTasks($event)">
</app-task-selection-modal>
